import { makeType, actionCreator } from "../../Utils/generateActionCreator";
import { API } from "aws-amplify";
import { toast } from "react-toastify";


const actionType = makeType("RATE");

export const MODIFY = actionType("MODIFY");
export const ERROR = actionType("ERROR");
export const LOADING = actionType("LOADING");
export const CHANGE = actionType("CHANGE");
export const OPEN_MODAL = actionType("OPEN_MODAL");



export const modifiyRate = actionCreator(MODIFY, "modifyRate");
export const errUpdateRate = actionCreator(ERROR, "error");
export const loading = actionCreator(LOADING, "loading");
export const changeRate = actionCreator(CHANGE, "rate");
export const openModalImproveRate = actionCreator(OPEN_MODAL, "isOpen");



export const modifySimulate = async (dispatch,idSimulation,rate) => {
    try{
        const request = {
            body: {
                idSimulation,
                tasa:parseFloat(rate)
            },
            headers: {}
          };
        dispatch(loading(true));
        const response = await API.post("api-rentas", "/improve-rate",request);
        if (response.success){
            dispatch(modifiyRate(response.success));
            dispatch(changeRate(rate));
            dispatch(openModalImproveRate(false));
            toast.success('actualización finalizada', {
                position: toast.POSITION.TOP_CENTER,
              });
        } 
        else{
            dispatch(errUpdateRate(response.message));
            toast.error('no se realizó la actualización', {
                position: toast.POSITION.TOP_CENTER,
                className: "toast-modal",
              });
        }

        dispatch(loading(false));
    }catch(e){
        dispatch(loading(false));
        dispatch(errUpdateRate(e))
    }

};

